import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useAppContext } from '../../../context/AppContext';
import 'react-toastify/dist/ReactToastify.css';
import { trans } from '../../../utils/utilsTrans';

const OfflineManager = ({ translations }) => {
  const { isOnline } = useAppContext();

  useEffect(() => {
    if (isOnline) {
      const message = trans('online', translations);
      message != 'online' ? toast.success(trans('online', translations)): null;
    } else {
      const message = trans('offline', translations);
      message != 'offline' ? toast.warn(trans('offline', translations)): null;
    }
  }, [isOnline, translations]);

  return (
    <>
      <ToastContainer />
    </>
  );
};

export default OfflineManager
